import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../redux/Action";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Signup = () => {
  const [social, setSocial] = useState(false);
  const [signup, setSignup] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Blogshog | Signup";
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSignup({
      ...signup,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const addresses = [];
    let obj = {},
      social = {};
    for (let keys in signup) {
      if (
        keys === "street" ||
        keys === "city" ||
        keys === "pincode" ||
        keys === "state"
      ) {
        obj[keys] = signup[keys];
      } else if (
        keys === "linked_in" ||
        keys === "twitter" ||
        keys === "instagram"
      ) {
        social[keys] = signup[keys];
      }
    }
    addresses.push(obj);
    let avatar = "";
    if (signup.gender === "male" || signup.gender === "other") {
      avatar =
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTFHZsc3xwRGK_buY_o47OogoecMLL8W_dfjw&usqp=CAU";
    } else {
      avatar =
        "https://cdn.pixabay.com/photo/2017/01/30/23/52/female-2022387_960_720.png";
    }
    const payload = {
      name: signup.name,
      email: signup.email,
      social_profile: social,
      password: signup.password,
      addresses,
      gender: signup.gender,
      avatar,
    };

    const id = toast.loading("Creating User...", { theme: "dark" });
    axios
      .post(`${baseURL}/signup`, payload)
      .then((res) => {
        toast.update(id, {
          render: res.data,
          type: "success",
          isLoading: false,
          theme: "dark",
          autoClose: 2000,
          closeOnClick: true,
        });
        navigate("/login");
      })
      .catch((err) => {
        toast.update(id, {
          render: err.response.data.error,
          type: "error",
          isLoading: false,
          autoClose: 2000,
          closeOnClick: true,
        });
      });
  };
  return (
    <>
      <h1 className="text-3xl mb-2 mt-14 text-center font-extrabold dark:text-white">
        Create Account
      </h1>
      <div className="lg:my-14 md:my-10 px-4 lg:w-[80%] m-auto ">
        <div className="md:grid md:grid-cols-2 md:gap-6">
          <div className="mt-5 md:mt-0 md:col-span-2">
            <form onSubmit={handleSubmit}>
              <div className="grid grid-cols-6 gap-6">
                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                  <label
                    htmlFor="name"
                    className="block text-sm font-medium text-gray-700 dark:text-white"
                  >
                    Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    pattern="[a-zA-Z\s]+"
                    minLength={3}
                    title="The name must not include numbers and special characters"
                    id="name"
                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md ouline outline-indigo-600 px-2 py-2 text-xl border border-grey-200 dark:bg-[#2d2f40] dark:border-gray-800 dark:text-white"
                    required
                    onChange={handleChange}
                  />
                </div>

                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                  <label
                    htmlFor="email-address"
                    className="block text-sm font-medium text-gray-700 dark:text-white"
                  >
                    Email address
                  </label>
                  <input
                    type="email"
                    name="email"
                    id="email-address"
                    pattern="^\S+@\S+\.\S+$"
                    title="Please enter a valid email!"
                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md ouline outline-indigo-600 px-2 py-2 text-xl border border-grey-200 dark:bg-[#2d2f40] dark:border-gray-800 dark:text-white"
                    required
                    onChange={handleChange}
                  />
                </div>
                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                  <label
                    htmlFor="password"
                    className="block text-sm font-medium text-gray-700 dark:text-white"
                  >
                    Password
                  </label>
                  <div className="relative w-full">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      id="password"
                      placeholder="********"
                      minLength={6}
                      className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md ouline outline-indigo-600 px-2 py-2 text-xl border border-grey-200 dark:bg-[#2d2f40] dark:border-gray-800 dark:text-white"
                      onChange={handleChange}
                      required
                    />
                    {showPassword && (
                      <FaEye
                        className="absolute top-3 right-5 cursor-pointer"
                        onClick={() => setShowPassword(!showPassword)}
                      />
                    )}
                    {!showPassword && (
                      <FaEyeSlash
                        className="absolute top-3 right-5 cursor-pointer"
                        onClick={() => setShowPassword(!showPassword)}
                      />
                    )}
                  </div>
                </div>

                <div className="col-span-3 sm:col-span-3 lg:col-span-3">
                  <label
                    htmlFor="gender"
                    className="block text-sm font-medium text-gray-700 dark:text-white"
                  >
                    Gender
                  </label>
                  <select
                    id="gender"
                    name="gender"
                    className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm dark:bg-[#2d2f40] dark:border-gray-800 dark:text-white"
                    required
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="col-span-3 sm:col-span-3 lg:col-span-3">
                  <label
                    htmlFor="social"
                    className="block text-sm font-medium text-gray-700 dark:text-white"
                  >
                    Social Profiles
                  </label>
                  <select
                    id="social"
                    name="social"
                    className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm dark:bg-[#2d2f40] dark:border-gray-800 dark:text-white"
                    onChange={(e) => {
                      if (e.target.value === "1") {
                        setSocial(true);
                      } else {
                        setSocial(false);
                      }
                    }}
                  >
                    <option value="-">Select</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </div>
                {social ? (
                  <>
                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                      <label
                        htmlFor="instagram"
                        className="block text-sm font-medium text-gray-700 dark:text-white"
                      >
                        Instagram
                      </label>
                      <input
                        type="text"
                        name="instagram"
                        id="instagram"
                        className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md ouline outline-indigo-600 px-2 py-2 text-xl border border-grey-200 dark:bg-[#2d2f40] dark:border-gray-800 dark:text-white"
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                      <label
                        htmlFor="twitter"
                        className="block text-sm font-medium text-gray-700 dark:text-white"
                      >
                        Twitter
                      </label>
                      <input
                        type="text"
                        name="twitter"
                        id="twitter"
                        className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md ouline outline-indigo-600 px-2 py-2 text-xl border border-grey-200 dark:bg-[#2d2f40] dark:border-gray-800 dark:text-white"
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                      <label
                        htmlFor="linked_in"
                        className="block text-sm font-medium text-gray-700 dark:text-white"
                      >
                        Linked-in
                      </label>
                      <input
                        type="text"
                        name="linked_in"
                        id="linked_in"
                        className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md ouline outline-indigo-600 px-2 py-2 text-xl border border-grey-200 dark:bg-[#2d2f40] dark:border-gray-800 dark:text-white"
                        onChange={handleChange}
                      />
                    </div>
                  </>
                ) : (
                  ""
                )}

                <div className="col-span-6">
                  <label
                    htmlFor="street-address"
                    className="block text-sm font-medium text-gray-700 dark:text-white"
                  >
                    Street address
                  </label>
                  <input
                    type="text"
                    name="street"
                    id="street-address"
                    autoComplete="street-address"
                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md ouline outline-indigo-600 px-2 py-2 text-xl border border-grey-200 dark:bg-[#2d2f40] dark:border-gray-800 dark:text-white"
                    required
                    onChange={handleChange}
                  />
                </div>

                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                  <label
                    htmlFor="city"
                    className="block text-sm font-medium text-gray-700 dark:text-white"
                  >
                    City
                  </label>
                  <input
                    type="text"
                    name="city"
                    id="city"
                    pattern="[a-zA-Z\s]+"
                    autoComplete="address-level2"
                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md ouline outline-indigo-600 px-2 py-2 text-xl border border-grey-200 dark:bg-[#2d2f40] dark:border-gray-800 dark:text-white"
                    required
                    onChange={handleChange}
                  />
                </div>

                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                  <label
                    htmlFor="region"
                    className="block text-sm font-medium text-gray-700 dark:text-white"
                  >
                    State / Province
                  </label>
                  <input
                    type="text"
                    name="state"
                    pattern="[a-zA-Z\s]+"
                    id="region"
                    autoComplete="address-level1"
                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md ouline outline-indigo-600 px-2 py-2 text-xl border border-grey-200 dark:bg-[#2d2f40] dark:border-gray-800 dark:text-white"
                    required
                    onChange={handleChange}
                  />
                </div>

                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                  <label
                    htmlFor="postal-code"
                    className="block text-sm font-medium text-gray-700 dark:text-white"
                  >
                    ZIP / Postal code
                  </label>
                  <input
                    type="text"
                    pattern="[A-Z0-9]+"
                    name="pincode"
                    id="postal-code"
                    minLength={4}
                    autoComplete="postal-code"
                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md ouline outline-indigo-600 px-2 py-2 text-xl border border-grey-200 dark:bg-[#2d2f40] dark:border-gray-800 dark:text-white"
                    required
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="px-4 py-3  text-right sm:px-6">
                <button
                  type="submit"
                  className="inline-flex w-full sm:w-auto justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Signup
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Signup;
